import React, { useEffect } from "react";
import '../../../assets/styles/pages/homeCss/purpose.css'
import ppl from '../../../assets/images/homeImages/all-ppl.png'
import AOS from "aos";


export default function Purpose() {

  useEffect(()=>{
    AOS.init({duration:2000, } , );
   },[])

  return (
    <>
   
      <section className="purpose-main">
      <h1 className="purpose-head text-center" data-aos='fade-down'>Purpose-built Tools for Holistic Wellbeing</h1>
      <div className="d-flex justify-content-center" data-aos='fade-down'>
      <p className="purpose-p">Accessible anytime, on any device; the Oxyzn platform is where you'll find purpose-built tools and resources to aid physical health and mental wellbeing.</p>
      </div>
      <div className="w-100">
      <img  data-aos='fade-up' className="w-100 mt-4" src={ppl} alt="" />
      </div>
      </section>
    </>
  );
}

